import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/image/fund/export-icon.png'


const _hoisted_1 = { class: "dialog-title" }
const _hoisted_2 = { class: "dialog-title-content" }
const _hoisted_3 = { class: "dialog-content" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 0,
  class: "flex-cen-ter paymentSerialNumber"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1)

import { ref, computed } from 'vue'
import { t } from '@/plugins/i18n'
import { getVipHistoryListApi } from '@/apis/fund'
import STable from '@/components/Table/index.vue'
import dayjs from 'dayjs'
import axios from 'axios'
import { useStore } from 'vuex'
import { exportFileDownload } from '@/util/useExport'
import CopyButton from '@/components/common/CopyButton.vue'
import { getJapanTime } from '@/util/common'
import { useSite, isEN, isJA } from '@/store'
import ModalFundFlowContent from '@/views/fund/FundList/components/ModalFundFlowContent.vue'
import useUserConfig, { ENUM_CONFIG_CODE } from '@/util/useUserConfig'
import { ASK_ENUM, responseReceiptData } from '@/views/setup/components/utils'


export default /*#__PURE__*/_defineComponent({
  props: {
  visible: {
    type: Boolean,
    default: false
  }
},
  emits: ['update:visible'],
  setup(__props, { emit }) {

const props = __props
const store = useStore()


const modalFundFlowContentRef = ref<InstanceType<typeof ModalFundFlowContent>>()
const [getSignUpValue] = useUserConfig(ENUM_CONFIG_CODE.RETAIL_BOOK)


const tableConfig = {
  showHandler: true,
  setHeight: true,
  handlerConfig: { label: t('操作') }
}
const close = () => {
  emit('update:visible', false)
}
const pageData = ref({
  page: 1,
  limit: 10
})
const filterData = computed(() => {
  return {

  }
})
const historyColumns = [
  {
    prop: 'createTime',
    label: t('生成时间'),
    slotName: 'createTime',
    width: 180
  },
  { prop: 'membershipPrechargeOrderId', label: t('会员订单编号'), width: 100 },
  {
    prop: 'payChannel',
    label: t('类型2'),
    slotName: 'payChannel',
    width: 180
  },
  {
    prop: 'effectiveStatus',
    label: t('状态2'),
    slotName: 'effectiveStatus',
    width: 160
  },
  {
    prop: 'membershipTemplateName',
    label: t('会员套餐'),
    slotName: 'membershipTemplateName',
    width: 200
  },
  {
    prop: 'payChannel2',
    label: t('支付方式'),
    slotName: 'payChannel2',
    width: 160
  },
  {
    prop: 'originPaymentAmount',
    label: t('支付价格（日元）'),
    slotName: 'originPaymentAmount',
    width: 160
  },
  {
    prop: 'paymentSerialNumber',
    label: t('流水号'),
    width: 200,
    slotName: 'paymentSerialNumber'
  },
  {
    prop: 'oldExpiresDate',
    label: t('会员有效期'),
    slotName: 'oldExpiresDate',
    width: 240
  }
]

// 导出记录
const downLoadFile = () => {
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/settlement/wallet/recharge/membership/exportCustomerMembershipOrder',
    data: {
      pageSize: 10000,
      pageNum: 1
    },
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    exportFileDownload(res, { name: t('明細') })
  })
}

const downloadPDF = async (row: any) => {
  if (!isJA()) {
    downLoadPdfFile(row)
    return
  }
  const res = await getSignUpValue()
  const lastUseData = responseReceiptData(res)
  if (lastUseData.askEveryTime === ASK_ENUM.NO_ASK) {
    downLoadPdfFile(row, lastUseData.content)
    return
  }
  modalFundFlowContentRef.value?.open(lastUseData.content, (value: string) => {
    downLoadPdfFile(row, value)
  })
}
// 导出请求书
const downLoadPdfFile = (row: any, documentHeader?: string) => {
  // TODO
  axios({
    method: 'post',
    url: process.env.VUE_APP_URL + '/settlement/wallet/recharge/membership/download',
    data: {
      membershipOrderId: row.membershipPrechargeOrderId,
      documentHeader
    },
    responseType: 'blob',
    headers: {
      'X-AuthToken': store.getters.token,
      'X-GRAY-TAG': process.env.VUE_APP_X_GRAY_TAG || '',
      'X-Platform': 'PC',
      'X-Appname': 'ckb-client-pc'
    }
  }).then((res: any) => {
    exportFileDownload(res, { type: 'application/pdf', name: `${t('收据')}` })
  })
}

return (_ctx: any,_cache: any) => {
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "custom-class": 'vip-history-dialog ' + _unref(useSite)(),
    "model-value": __props.visible,
    onClose: close,
    "append-to-body": "",
    "show-close": false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)('会员开通记录')), 1),
        _createElementVNode("span", {
          class: "iconfont icon-guanbi2",
          onClick: close
        })
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(STable, {
          api: _unref(getVipHistoryListApi),
          columns: historyColumns,
          "page-data": pageData.value,
          "onUpdate:page-data": _cache[0] || (_cache[0] = ($event: any) => ((pageData).value = $event)),
          ref: (_value, _refs) => {
            _refs['historyTable'] = _value
          },
          filterData: _unref(filterData),
          "table-config": tableConfig
        }, {
          payChannel: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.createChannel === 0 ? _unref(t)('活动赠送(推广联盟)') : row.payChannel === 2 ? _unref(t)('活动赠送') : (row.membershipTemplateId ===
                row.oldMembershipTemplateId ? _unref(t)('自动续费') :
                row.trialFlag ? _unref(t)('新人试用活动') : _unref(t)('开通会员2'))), 1)
          ]),
          effectiveStatus: _withCtx(() => [
            _createElementVNode("div", null, _toDisplayString(_unref(t)('开通成功')), 1)
          ]),
          membershipTemplateName: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              _createTextVNode(_toDisplayString(row.membershipTemplateName) + " ", 1),
              (row.payChannel !== 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_4, "(" + _toDisplayString(_unref(t)('X个月').replace('X', row.membershipPackageName)) + ")", 1))
                : _createCommentVNode("", true)
            ])
          ]),
          payChannel2: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.payChannel === 1 ? 'paypal' : row.payChannel === 3 ? _unref(t)('paypal信用卡') : row.payChannel === 4 ? _unref(t)('余额')
                : '-'), 1)
          ]),
          oldExpiresDate: _withCtx(({ row }) => [
            _createElementVNode("div", null, [
              (row.oldExpiresDate.indexOf('2999') === -1)
                ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(dayjs)(row.oldExpiresDate).add(1,
                'day').format('YYYY-MM-DD')) + _toDisplayString(_unref(t)('至')), 1))
                : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_unref(t)('结束日期')) + "：", 1)),
              _createTextVNode(" " + _toDisplayString(_unref(dayjs)(row.expiresDate).format('YYYY-MM-DD')), 1)
            ])
          ]),
          originPaymentAmount: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(row.payChannel !== 2 ? (_unref(isEN)() ? row.originPaymentAmount.toFixed(2) : row.originPaymentAmount) : '-'), 1)
          ]),
          paymentSerialNumber: _withCtx(({ row }) => [
            (row.paymentSerialNumber && row.payChannel !== 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _createElementVNode("span", null, _toDisplayString(row.paymentSerialNumber), 1),
                  _createVNode(CopyButton, {
                    text: row.paymentSerialNumber
                  }, null, 8, ["text"])
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_8, "-"))
          ]),
          handler: _withCtx(({ scope }) => [
            _createElementVNode("div", null, [
              (scope.row.payChannel !== 2 && scope.row.createChannel !== 0 && scope.row.originPaymentAmount !== 0)
                ? (_openBlock(), _createElementBlock("a", {
                    key: 0,
                    class: "down-file",
                    onClick: ($event: any) => (downLoadPdfFile(scope.row))
                  }, _toDisplayString(_unref(t)('入金領収書ダウンロード')), 9, _hoisted_9))
                : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
            ])
          ]),
          createTime: _withCtx(({ row }) => [
            _createElementVNode("div", null, _toDisplayString(_unref(getJapanTime)(row.createTime)), 1)
          ]),
          _: 1
        }, 8, ["api", "page-data", "filterData"]),
        _createElementVNode("div", {
          class: "btn-item",
          onClick: downLoadFile
        }, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('导出记录')), 1)
        ])
      ]),
      _createVNode(ModalFundFlowContent, {
        ref: (_value, _refs) => {
          _refs['modalFundFlowContentRef'] = _value
          modalFundFlowContentRef.value = _value
        }
      }, null, 512)
    ]),
    _: 1
  }, 8, ["custom-class", "model-value"]))
}
}

})